import { Button } from "@/components/ui/baseUi/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/baseUi/dialog"
import { Text } from "@/components/ui/baseUi/text"
import ObjectivesBackground from "@images/objectivesBackground.jpeg"
import { word } from "@modules/core/utils/i18n"
import { ObjectivesPopup } from "@modules/dashboard/components/objectivesPopup"
import { useObjectivePrimary } from "@modules/objectives/hooks/useObjectives"
import dayjs from "dayjs"
import { Compass, PencilIcon, Plus } from "lucide-react"
import { useState } from "react"

export function ObjectivesResume({ ...props }: React.ComponentProps<"div">) {
  const [isObjectivesPopupDisplayed, setIsObjectivesPopupDisplayed] = useState<boolean>(false)

  const { result: objectivePrimary, refresh } = useObjectivePrimary()

  const showObjectivesPopup = () => {
    setIsObjectivesPopupDisplayed(true)
  }

  const hideObjectivesPopup = () => {
    setIsObjectivesPopupDisplayed(false)
    refresh()
  }

  return (
    <div
      className="relative flex h-full min-h-[250px] w-full flex-col overflow-hidden rounded-4xl bg-right! px-7 py-5"
      style={{
        background: `linear-gradient(180deg, #121212 0%, rgba(18, 18, 18, 0.5) 100%), url(${ObjectivesBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      {...props}
    >
      <div className="flex flex-row justify-between gap-4">
        <div className="flex flex-col">
          <div className="mb-2 flex items-center">
            <Compass className="mr-2 text-white" size={15} />
            <Text fontStyle="TL" className="text-white">
              {word("dashboard.objectives.title")}
            </Text>
          </div>
          <Text fontStyle="BS" className="text-white">
            {word("dashboard.objectives.description")}
          </Text>
        </div>

        {objectivePrimary?.objective && (
          <Button onClick={showObjectivesPopup} size="iconMd">
            <PencilIcon color="currentColor" />
          </Button>
        )}
      </div>

      {objectivePrimary?.objective ? (
        <div className="flex grow flex-col items-center justify-center">
          <Text fontStyle="TL" className="text-center wrap-anywhere text-white">
            {objectivePrimary.objective}
          </Text>
          <div className="mt-2 flex items-center">
            <Text fontStyle="BS" className="text-white">
              {`${word("dashboard.objectives.beforeThe")} ${dayjs(objectivePrimary.targetDate).format("dddd D MMMM YYYY")}`}
            </Text>
          </div>
        </div>
      ) : (
        <div
          onClick={showObjectivesPopup}
          className="flex grow cursor-pointer flex-col items-center justify-center transition-all duration-150 hover:scale-105"
        >
          <Button size="iconMd" variant="secondary">
            <Plus color="currentColor" className="text-textDefault-body" width={14} height={14} />
          </Button>
          <Text className="my-2 text-white" fontStyle="LL">
            {word("dashboard.objectives.addGoal")}
          </Text>
        </div>
      )}

      <Dialog open={isObjectivesPopupDisplayed} onOpenChange={setIsObjectivesPopupDisplayed}>
        <DialogContent className="flex w-130 flex-col gap-4">
          <DialogHeader>
            <DialogTitle>{word("dashboard.objectives.addGoal")}</DialogTitle>
          </DialogHeader>

          <div>
            <ObjectivesPopup
              hideObjectivesPopup={hideObjectivesPopup}
              objectivePrimary={objectivePrimary ? objectivePrimary : null}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
